"use client";

import type React from "react";
import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { KnowledgeBaseDetails } from "./KnowledgeBaseDetails";
import type { WhatsAppKnowledgeBase } from "../../whatsapp-services/knowledgeBaseService";

interface KnowledgeBaseDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  knowledgeBase: WhatsAppKnowledgeBase | null;
  onRefresh: (updatedKnowledgeBase?: WhatsAppKnowledgeBase) => void;
}

export const KnowledgeBaseDetailsModal: React.FC<
  KnowledgeBaseDetailsModalProps
> = ({ isOpen, onClose, knowledgeBase, onRefresh }) => {
  const [isPolling, setIsPolling] = useState(false);

  if (!knowledgeBase) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent bg={"white"} maxW="800px" maxH="90vh" overflow="hidden">
        <ModalHeader color={"gray.800"}>Knowledge Base Details</ModalHeader>
        <ModalCloseButton color={"gray.800"} />
        <ModalBody p={0} overflowY="auto" maxH="calc(90vh - 120px)">
          <KnowledgeBaseDetails
            knowledgeBase={knowledgeBase}
            onRefresh={onRefresh}
            isPolling={isPolling}
            setIsPolling={setIsPolling}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
